import baseOptions from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import abbreviateNumber from '../../../utils/abbreviateNumber';

// Scatter plots each member of a dimension as an (x, y) point, where x is the
// first metric (series[0]) and y is the second (series[1]). It reuses the
// standard metric + dimension pipeline; the data hook joins the two metrics'
// responses per dimension member. Scatter is a Highcharts core type — no extra
// module needed.
const scatter = ({
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
  formatMetric,
  xMetricId,
  yMetricId,
  xMetricName,
  yMetricName,
  dateScope,
}) => {
  const axisLabelFormatter = function () {
    const abbreviated = abbreviateNumber(this.value);
    if (abbreviated) {
      return abbreviated.abbreviated.toLowerCase();
    }
    return this.axis.defaultLabelFormatter.call(this);
  };

  return {
    ...baseOptions(formatMetric),
    chart: {
      ...baseOptions(formatMetric).chart,
      type: 'scatter',
      marginTop: 24,
      zoomType: 'xy',
    },
    title: {
      ...baseOptions(formatMetric).title,
      text: title,
    },
    legend: {
      ...baseOptions(formatMetric).legend,
      enabled: false,
    },
    xAxis: {
      title: {
        enabled: true,
        text: xMetricName,
        style: { fontSize },
      },
      labels: {
        style: { fontSize },
        formatter: axisLabelFormatter,
      },
    },
    yAxis: {
      title: {
        enabled: true,
        text: yMetricName,
        style: { fontSize },
      },
      labels: {
        style: { fontSize },
        formatter: axisLabelFormatter,
      },
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 4,
          states: {
            hover: {
              enabled: true,
              lineColor: 'var(--color-border-primary)',
            },
          },
        },
      },
      series: {
        allowPointSelect: true,
        point: {
          events: {
            click: function () {
              if (openMenu) {
                const { metricIds } = this.series.userOptions;
                openMenu(
                  metricIds,
                  buildDrillDown(
                    groupField,
                    fieldType,
                    this.name,
                    chartDef,
                    dateScope,
                  ),
                );
              } else {
                const { onDrillDown } = this.series.userOptions;
                if (!onDrillDown) {
                  alert('Coming soon...');
                  return;
                }
                onDrillDown(this.name);
              }
            },
          },
        },
      },
    },
    tooltip: {
      ...baseOptions(formatMetric).tooltip,
      shared: false,
      useHTML: true,
      pointFormatter: function () {
        const x = formatMetric({ metricId: xMetricId, value: this.x });
        const y = formatMetric({ metricId: yMetricId, value: this.y });
        // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
        return (
          `<b>${this.name}</b><br/>` +
          `<span style="color: var(--color-text-muted);">${xMetricName}: </span><b>${x}</b><br/>` +
          `<span style="color: var(--color-text-muted);">${yMetricName}: </span><b>${y}</b>`
        );
      },
    },
  };
};

export default scatter;
